import type { RootState } from 'reducers/index';

export type I18nState = RootState['i18n'];

export const getState = (state: RootState): I18nState => state.i18n;
